import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import type { TutorialChapter } from '@il-colpo/engine';
import { useSettings } from '../../state/settingsStore.ts';
import { Button, Modal } from '../../ui/index.ts';
import { useGameStore } from '../gameStore.ts';
import { tutorialSetup } from './setup.ts';

export interface ChapterCompleteProps {
  chapter: TutorialChapter;
  open: boolean;
  /** Keeps playing the same heist. */
  onKeep: () => void;
}

/** Shown when a chapter has taught its lesson: go on, keep playing, or go back to the list. */
export function ChapterComplete({ chapter, open, onKeep }: ChapterCompleteProps) {
  const { t } = useTranslation('tutorial');
  const { t: ts } = useTranslation('setup');
  const navigate = useNavigate();
  const { language } = useSettings();
  const start = useGameStore((s) => s.start);
  const leave = useGameStore((s) => s.leave);
  const next = chapter.id < 5 ? ((chapter.id + 1) as 2 | 3 | 4 | 5) : null;

  return (
    <Modal
      open={open}
      onClose={onKeep}
      title={t('complete.title', { n: chapter.id })}
      actions={
        <>
          <Button
            variant="ghost"
            onClick={() => {
              leave();
              void navigate('/play/tutorial');
            }}
          >
            {t('complete.menu')}
          </Button>
          <Button variant="secondary" onClick={onKeep}>
            {t('complete.keep')}
          </Button>
          {next ? (
            <Button
              onClick={() => {
                void start(tutorialSetup(next, ts('you'), language));
              }}
            >
              {t('complete.next')}
            </Button>
          ) : null}
        </>
      }
    >
      <p>{next ? t('complete.body') : t('complete.bodyLast')}</p>
    </Modal>
  );
}
